import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { StandardPurityHome } from './pages/StandardPurityHome';
export function StandardPurityApp() {
  return <Routes data-id="element-1202">
      <Route path="/" element={<StandardPurityHome data-id="element-1204" />} data-id="element-1203" />
    </Routes>;
}